<template>
  <div>
    <transition name="slide" />
  </div>
</template>

<script>
/* eslint-disable */
import CookieControl from "CookieControl";

export default {
  name: "gdprbanner",

  props: {
    updateConsent: Boolean
  },

  data() {
    return {
      config: {
        product: 'PRO_MULTISITE',
        apiKey: '25038b305ba62374cc8470cd6c1150ef0ae637eb',
        necessaryCookies: [
          "affiliate",
          "countrycode",
          "bbdist"
        ],
        optionalCookies: [
          {
            name: "analytics",
            label: "Analytical Cookies",
            description:
              "These improve our website by collecting/reporting information on its usage.",
            cookies: ['_ga', '_gid', '_gat', '__utma', '__utmt', '__utmb', '__utmc', '__utmz', '__utmv', 'gtm', '_gcl_au', 'jv_*', '_ym_*', '_hjIncludedInSample'],
            onAccept: function() {
              // GA
              (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
              })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

              ga('create', 'UA-6899003-1', 'auto');
              ga('send', 'pageview');
            },
            onRevoke: function() {
              // GA
              window['ga-disable-UA-6899003-1'] = true;
            },
            recommendedState: true
          },
          {
            name : 'marketing',
            label: 'Marketing Cookies',
            description: 'We use marketing cookies to help us improve the relevancy of advertising campaigns you receive.',
            cookies: ['fr'],
            onAccept : function(){
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                  n.queue=[];t=b.createElement(e);t.async=!0;
                  t.src=v;s=b.getElementsByTagName(e)[0];
                  s.parentNode.insertBefore(t,s)}(window,document,'script',
                  'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '317442309668128');
              fbq('track', 'PageView');
              fbq('consent', 'grant');
            },
            onRevoke: function() {
              if (!typeof fbq) {
                fbq('consent', 'revoke');
              }
            },
            recommendedState: true
          },
        ],
        mode: 'gdpr',
        consentCookieExpiry: 90,
        statement: {
            description: 'For more information please see our',
            name: 'Privacy Statement',
            url: 'https://www.pilates.com/company/balanced-body-privacy-policy',
            updated: '01/07/2019'
        },
        logConsent: false,
        subDomains: false,
        initialState: 'notify',
        theme: 'light',
        acceptBehaviour: 'recommended',
        text: {
            necessaryDescription: 'These enable core functionality (e.g. page navigation, secure area access). The website cannot function without them. They can be disabled by changing browser preferences.',
            notifyDescription: 'We use cookies to optimize site functionality and give you the best possible experience.',
        },
        branding: {
          fontSizeHeaders: "1.3rem",
          fontSize: "1rem",
          removeIcon: true,
          removeAbout: true
        }
      }
    };
  },

  mounted() {
      CookieControl.load(this.config);
  },

  watch: {
    updateConsent() {
      this.openConsentWidget();
      this.$emit('update:showConsent', false);
    }
  },

  methods: {
    openConsentWidget() {
      CookieControl.open();
    }
  }
};
</script>

<style>
#ccc-notify-reject {
  display: none;
}

#ccc #ccc-notify {
  padding: 50px 100px !important;
}
</style>
